import { FetchBannerApiData } from '../../../../Shared/AttraxTs/Generic/FetchBannerPoolApiData';

interface BannerPool {
    banners: Banner[]
    cssClass: string
    id: string
    height: number
    width: number
    isExactHeight: boolean
    isExactWidth: boolean
}

export interface Banner {
    altTagText: string
    cssClass: string
    customHtml: string
    id: string
    imageId: string
    sortOrder: number
    targetUrl: string
    title: string
}

export const fetchBanners = async (dataIdentifier: string, includeCustomHTML: boolean): Promise<Banner[]> => {
    try {
        const result: BannerPool = await FetchBannerApiData({
            displayCount: 99,
            dataIdentifier,
            includeCustomHTML: includeCustomHTML,
        });

        const sortedBanners = result.banners.slice().sort((a, b) => a.sortOrder - b.sortOrder);

        return sortedBanners;

    } catch (error) {
        console.error('Error fetching brand banner data:', error);
        throw error;
    }
};
